import React from 'react';
import hexToRgba from 'hex-to-rgba';



const BSResults = (props) => {



  if (props.terms.opacity < 1){
   var shadowColor = hexToRgba(props.terms.shadowColor, props.terms.opacity);
  } else {
    var shadowColor = props.terms.shadowColor;
  }



  const divStyles = {
    margin: "0 auto",
    width: "200px",
    height: "200px",
    backgroundColor: props.terms.boxColor,
    boxShadow: `${props.terms.horizontalLength}px ${props.terms.verticalLength}px ${props.terms.blurRadius}px ${props.terms.spreadRadius}px ${shadowColor}`
  }

  const containerStyles = {
    backgroundColor: props.terms.backgroundColor,
  }

    return (
      <div className="ui segment" style={containerStyles}>
      <div className="result center"> 
        <div className="BSResultText ui segment">
        <span>box-shadow: {props.terms.horizontalLength}px {props.terms.verticalLength}px {props.terms.blurRadius}px {props.terms.spreadRadius}px {shadowColor};</span>
        <span>-moz-box-shadow: {props.terms.horizontalLength}px {props.terms.verticalLength}px {props.terms.blurRadius}px {props.terms.spreadRadius}px {shadowColor};</span>
        <span>-webkit-box-shadow: {props.terms.horizontalLength}px {props.terms.verticalLength}px {props.terms.blurRadius}px {props.terms.spreadRadius}px {shadowColor};</span>
        </div>


        <div className="BSResultDiv" style={divStyles}>
        </div>
      </div>
      </div>
    );
}

export default BSResults;